import { render } from "./CsvIcon.vue?vue&type=template&id=d4873438"
const script = {}
script.render = render

export default script